function NotFound() {
  return (
    <div className="py-8">
      <h1 className="text-4xl font-bold text-center">404 - Not Found</h1>
      <p className="mt-4 text-lg text-center">The page you are looking for does not exist.</p>
    </div>
  );
}

export default NotFound;
